var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SharedNavigation',{scopedSlots:_vm._u([{key:"search",fn:function(){return [_c('HeaderSearch',{on:{"search":_vm.search}})]},proxy:true},{key:"icon-items",fn:function(){return [_c('BasketNavItem',{}),_c('FavouriteNavItem',{on:{"clicked":_vm.searchByFavourites}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }